<template>
  <div class="fixed z-10 inset-0 overflow-y-auto" style="min-height: 500px;">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" @click="closeModal"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
            <span class="sr-only">Close</span>
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <div class="mt-3 text-center sm:mt-0 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                {{transEdit('register-expenditures')}}
              </h3>
            </div>
            <div class="pt-4 space-y-8">
              <div class="sm:col-span-6">
                <label for="add-expenditure-modal-date" class="block text-sm font-medium text-gray-700">
                  {{transEdit('date')}}
                </label>
                <div class="mt-1">
                  <input v-model="date" type="date" id="add-expenditure-modal-date" class="shadow-sm focus:ring-indigo-500 focus:border-tlmblue2 block w-full sm:text-sm border-gray-300 rounded-md">
                </div>
              </div>
              <div class="sm:col-span-6">
                <label for="add-expenditure-modal-description" class="block text-sm font-medium text-gray-700">
                  {{transEdit('article')}}
                </label>
                <div class="mt-1">
                  <input type="text" id="add-expenditure-modal-description" class="shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 block w-full sm:text-sm border-gray-300 rounded-md" required>
                </div>
              </div>
              <div class="sm:col-span-6">
                <label for="add-expenditure-modal-description" class="block text-sm font-medium text-gray-700">
                  {{transEdit('price')}} (exklusive moms)
                </label>
                <div class="mt-1">
                  <input type="text" id="add-expenditure-modal-price" class="shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 block w-full sm:text-sm border-gray-300 rounded-md" required>
                </div>
                <p id="add-expenditure-modal-price-invalid" class="mt-2 text-sm text-red-500">
                  Du måste fylla i ett pris!
                </p>
              </div>
              <div class="col-span-6 sm:col-span-3">
                <label for="add-expenditure-modal-vat" class="block text-sm font-medium text-gray-700">{{transEdit('expenditures-sum-only-vat')}}</label>
                <select id="add-expenditure-modal-vat" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-tlmblue2 focus:border-tlmblue2 sm:text-sm">
                  <option value="25" selected>25%</option>
                  <option value="12">12%</option>
                  <option value="6">6%</option>
                  <option value="0">0%</option>
                </select>
              </div>
              <div class="sm:col-span-6">
                <label for="add-expenditure-modal-reason" class="block text-sm font-medium text-gray-700">
                  {{transEdit('reason-for-purchase')}}
                </label>
                <div class="mt-1">
                  <textarea id="add-expenditure-modal-reason" rows="3" class="shadow-sm focus:ring-tlmblue2 focus:border-tlmblue2 block w-full sm:text-sm border-gray-300 rounded-md"></textarea>
                </div>
              </div>

            </div>
          </div>
          <div class="pt-5">
            <div class="flex justify-end">
              <button type="button" @click="closeModal"
                      class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
                {{ transEdit('cancel') }}
              </button>
              <button type="submit" @click="addExpenditure"
                      class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-tlmblue2 hover:bg-tlmblue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
                {{transEdit('register-expenditures')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "therapist-dash-modal-add-expenditure",
        props: ['route_add_expenditure', 'date'],
        methods: {
            addExpenditure: function () {
                let self = this;
                let thisModal = $("#add-expenditure-modal");

                let priceInput = $("#add-expenditure-modal-price");
                let price = priceInput.val();

                let vatInput = $("#add-expenditure-modal-vat");
                let vat = vatInput.val();

                let expenditureDescriptionInput = $("#add-expenditure-modal-description");
                let expenditureDescription = expenditureDescriptionInput.val();

                let expenditureReasonInput = $("#add-expenditure-modal-reason");
                let expenditureReason = expenditureReasonInput.val();

                if (!price) {
                    $("#add-expenditure-modal-price-invalid").show();
                } else {
                    axios.post(this.$portalUrl(self.route_add_expenditure), {
                        date: this.date,
                        price: price,
                        vat: vat,
                        description: expenditureDescription,
                        reason: expenditureReason,
                    })
                    .then(function (response) {
                      self.$emit('close');
                    })
                    .catch(function (error) {
                    });

                    thisModal.modal('toggle');
                }
            },
          closeModal() {
            this.$emit('close');
          },
        },
      mounted() {
        let addExpenditureModalDate = $("#add-expenditure-modal-date");
        let addExpenditureModalPriceInvalid = $("#add-expenditure-modal-price-invalid");
        addExpenditureModalDate = this.date;
        addExpenditureModalPriceInvalid.hide();
      }
    }
</script>

<style scoped>

</style>
